var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "k-page",
    { staticClass: "home" },
    [
      _vm.layout === "suave"
        ? [_c("k-browser-content")]
        : [
            _c(
              "d-main-image",
              _vm._b(
                { on: { load: _vm.pageLoaded } },
                "d-main-image",
                { img: _vm.img, show: _vm.show },
                false
              )
            ),
            _c("k-hero"),
            _c("w-go-down"),
            _c(
              "k-main",
              { attrs: { title: _vm.title } },
              [
                _c("content-list", {
                  attrs: { title: "latest", contents: _vm.latest },
                }),
                _c("filmstrip", {
                  attrs: { title: "trending", contents: _vm.trending },
                }),
                _c("filmstrip", {
                  attrs: { title: "recent activity", contents: _vm.recent },
                }),
                _c("filmstrip", {
                  attrs: { title: "pull up", contents: _vm.history },
                }),
                _c("filmstrip", {
                  attrs: { title: "you might like", contents: _vm.discovery },
                }),
                _c("filmstrip", {
                  attrs: { title: "my faves", contents: _vm.favs },
                }),
              ],
              1
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }